import React, { useState, useEffect } from 'react';
import SectionTitle from '../../elements/section-title/SectionTitle';
import ModulePlansSoftweb from "../../data/plans/modulePlansSoftweb.json";
import { Link } from 'react-router-dom';
import { FaCheck } from "react-icons/fa";
import { getBillingPackages } from '../../api/services/packagesSoftweb';

const filters = [
  { id: 1, label: "Facturacion", content: "A" },
  { id: 2, label: "Punto De Venta", content: "P" },
  { id: 3, label: "Nomina", content: "B" },
  { id: 4, label: "Contabilidad", content: "C" }
];

const getModulePlansSoftweb = ModulePlansSoftweb;

const ProjectOne = ({ parentClass, activeFilterId }) => {
  const [activeFilter, setActiveFilter] = useState(filters[0]);

  useEffect(() => {
    const filterSelected = filters.find(filter => filter.id === activeFilterId);

    if (filterSelected) {
      setActiveFilter(filterSelected);
    }
  }, [activeFilterId]);

  useEffect(async() => {
    console.log(await getBillingPackages());
  }, [])

  const handleChange = (filter) => {
    setActiveFilter(filter);
  };

  // const pruebaPaquetes = async () => {
  //   try {
  //     console.log(await getBillingPackages())
  //     console.log('algo')
  //   } catch {

  //   }
  // };

  return (
    <>
      <div className={`section section-padding-2 ${parentClass ? parentClass : ""}`}>
        <div className="container">
          <SectionTitle
            subtitle="Nuestros Planes"
            title="Los servicios que<br>podrias necesitar."
            textAlignment="heading-left mb--40"
          />

          <div className="isotope-button isotope-project-btn">
            {filters.map((filter) => (
              <button
                onClick={() => handleChange(filter)}
                className={filter.label === activeFilter.label ? "is-checked" : ""}
                key={filter.id}
              >
                {filter.label}
              </button>
            ))}
          </div>

          {/* <button onClick={pruebaPaquetes}>Iniciar sesión</button> */}

          {/* Aquí en lugar de grid, muestra la letra o contenido que toque */}
          <div className="row mt-5">
            {/* {activeFilter.id} */}
            {/* <h2>{activeFilter.content}</h2> */}
            {getModulePlansSoftweb.filter(paquete => paquete.type === activeFilter.id).map((data, index) => (
                <div className="col-lg-3" key={index}>
                    <div className="pricing-table pricing-borderd">
                        <div className="pricing-header">
                            <h3 className="title">{data.title}</h3>
                            <span className="subtitle">{data.subtitle}</span>
                            <div className="price-wrap">
                                <div className="yearly-pricing">
                                    <span className="amount">{data.yprice}</span>
                                    <span className="duration">{data.yduration}</span>
                                </div>
                            </div>
                            <div className="pricing-btn">
                                {/* <Link to="#" className="axil-btn btn-large btn-borderd">Agregar al carrito</Link> */}
                                <a href="https://wa.me/5214494130113" className="axil-btn btn-large btn-borderd">Contáctanos</a>
                            </div>
                        </div>
                        <div className="pricing-body">
                            <ul className="list-unstyled">
                                {data.facility.map((data, index) => (
                                    <li key={index}><FaCheck /> {data}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            ))}

          </div>

        </div>
      </div>
    </>
  );
};

export default ProjectOne;
